/* eslint-disable jira/filename-case */
import {
	createLayout,
	type Layout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';

export const userBoardLayout: Layout = createLayout();
